










































































































































































































































































import {Component, Prop, Vue, Watch,} from 'vue-property-decorator';
import {AxiosStatic} from "axios";
import IResource from "@/interfaces/IResource";
import MailAttachment from '@/components/MailAttachment.vue';

@Component({
	components: {MailAttachment},
})
export default class ResourceEmailText extends Vue {
	public defaultReservationText: string = "Vielen Dank, wir bestätigen gerne deine Reservation.";
	public defaultReservationRequestText: string = "Vielen Dank für deine Anfrage.";
	public defaultCancelText: string = '';
	public defaultConfirmationText: string = "Wir freuen uns, deine Reservation zu bestätigen:";
	public defaultChangeReservationText: string = "Wir freuen uns, deine Reservationsänderung zu bestätigen:";
	public newCancelReservationEmailText: string = '';
	public newReservationEmailText: string = '';
	public newConfirmationEmailText: string = '';
	public newChangeReservationEmailText: string = '';

	public notificationEmail: string = '';
	public showNotificationEmailError: boolean = false;

	public attachment: string | null = '';
	public attachmentName: string | null = '';
	public attachmentMime: string | null = '';
	public attachmentSize: number | null = null;
	public delete_attachment: boolean = false;
	public showInvalidAttachmentSize: boolean = false;

	public isSaving: boolean = false;

	public $http!: AxiosStatic;

	public $refs!: {
		attachment_uploader: HTMLInputElement;
	};

	@Prop({
		required: true,
		type: Number
	})
	public resourceId!: number;

	get resource(): IResource | null {
		if (this.$store.state.resources) {
			let filtered = this.$store.state.resources.filter((r: IResource) => r.id == this.resourceId);
			if (filtered.length > 0) {
				return filtered[0];
			}
		}
		return null;
	}

	get user() {
		return this.$store.state.user;
	}

	@Watch('resource', { immediate: true })
	public watchResource() {
		if (this.resource && this.newReservationEmailText == '') {
			if (this.resource.reservation_email_text == null) {
				if (this.resource.auto_confirm) {
					this.newReservationEmailText = this.defaultReservationText;
				} else {
					this.newReservationEmailText = this.defaultReservationRequestText;
				}
			} else {
				this.newReservationEmailText = this.resource.reservation_email_text;
			}
		}
		if (this.resource && this.newConfirmationEmailText == '') {
			if (this.resource.confirmation_email_text == null) {
				this.newConfirmationEmailText = this.defaultConfirmationText;
			} else {
				this.newConfirmationEmailText = this.resource.confirmation_email_text;
			}
		}
		if (this.resource && this.newChangeReservationEmailText == '') {
			if (this.resource.change_reservation_email_text == null) {
				this.newChangeReservationEmailText = this.defaultChangeReservationText;
			} else {
				this.newChangeReservationEmailText = this.resource.change_reservation_email_text;
			}
		}
		if (this.resource && this.newCancelReservationEmailText == '') {
			if (this.resource.cancel_email_text == null) {
				this.newCancelReservationEmailText = this.defaultCancelText;
			} else {
				this.newCancelReservationEmailText = this.resource.cancel_email_text;
			}
		}
		if (this.resource && this.resource.notification_email) {
			this.notificationEmail = this.resource.notification_email;
		} else {
			this.notificationEmail = '';
		}
		if (this.resource && this.resource.confirmation_email_attachment) {
			this.attachment = this.resource.confirmation_email_attachment;
			this.attachmentName = this.resource.confirmation_email_attachment_name;
			this.attachmentMime = this.resource.confirmation_email_attachment_mime;
			this.attachmentSize = this.resource.confirmation_email_attachment_size;
		} else {
			this.attachment = '';
			this.attachmentName = null;
			this.attachmentMime = null;
			this.attachmentSize = null;
		}
	}

	public async mounted(): Promise<void> {
		this.$store.dispatch('loadResources', {root: true});
	}

	public validateEmail(email: string) {
		if (email) {
			// regex from https://stackoverflow.com/questions/46155/how-to-validate-an-email-address-in-javascript
			let re: RegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			return re.test(String(email).toLowerCase().trim());
		}
		return true;
	}

	public async saveEmailTexts() {
		if (this.resource) {

			// validate notification emails
			this.showNotificationEmailError = false;
			if (this.notificationEmail) {
				let emails = this.notificationEmail.split(',');
				emails.forEach(email => {
					if (!this.validateEmail(email)) {
						this.showNotificationEmailError = true;
					}
				})
			}
			if (this.showNotificationEmailError) {
				return;
			}

			this.isSaving = true;

			let formData = new FormData();
			formData.append('reservation_email_text', String(this.newReservationEmailText));
			formData.append('cancel_email_text', String(this.newCancelReservationEmailText));
			formData.append('notification_email', String(this.notificationEmail));
			if (this.resource.auto_confirm) {
				formData.append('change_reservation_email_text', String(this.newChangeReservationEmailText));
			} else {
				formData.append('confirmation_email_text', String(this.newConfirmationEmailText));
			}
			if (!this.showInvalidAttachmentSize) {
				if (this.delete_attachment) {
					formData.append('delete_attachment', 'true')
				} else {
					if (this.$refs.attachment_uploader && this.$refs.attachment_uploader.files && this.$refs.attachment_uploader.files.length > 0) {
						formData.append('confirmation_email_attachment', this.$refs.attachment_uploader.files[0])
						formData.append('confirmation_email_attachment_name', this.$refs.attachment_uploader.files[0].name)
						formData.append('confirmation_email_attachment_mime', this.$refs.attachment_uploader.files[0].type)
					}
				}
			}

			await Vue.prototype.$http.post(
				`/private/resource/${this.resource.id}`,
				formData,
				{
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				}
			);

			this.isSaving = false;
			this.delete_attachment = false;
			this.$store.dispatch('loadResources', {root: true});
		}
	}

	public checkAttachment(): void {

		if (this.$refs.attachment_uploader && this.$refs.attachment_uploader.files && this.$refs.attachment_uploader.files.length > 0) {
			if (this.$refs.attachment_uploader.files[0].size > 1024*1024) {
				this.showInvalidAttachmentSize = true;
				return;
			}

			this.showInvalidAttachmentSize = false;
			this.delete_attachment = false;
			this.attachmentName = this.$refs.attachment_uploader.files[0].name;
			this.attachmentMime = this.$refs.attachment_uploader.files[0].type;
			this.attachmentSize = this.$refs.attachment_uploader.files[0].size;
		}
	}
}
